import React from "react";
import { Dialog } from '@mui/material';
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { texts } from "../../../../general/texts";
import colors from "../../../../colors";

const ConfirmDonation = ({ isDialogOpened, handleClose, confirmDonation, amount }) => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    return (
        <Dialog
            open={isDialogOpened}
            onClose={handleClose}
            keepMounted
            fullWidth
            maxWidth="lg"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    width: '500px',
                    height: isSmallScreen ? '30vh' : '240px',
                    padding: isSmallScreen ? '15px' : '15px 85px',
                    zIndex: 888,
                    justifyContent: 'center',
                    background: colors.white
                },
            }}
        >
          <div>
            <p style={{textAlign: 'center', fontSize: '35px', fontFamily: 'GerberaBold', color: colors.orange, margin: '0px'}}>{amount} ALL</p>
            <p style={{textAlign: 'center', fontSize: '20px', fontFamily: 'GerberaMedium', color: colors.darkBlue, margin: '0px'}}>{texts['message-held-amount']}</p>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 30}}>
                <button onClick={handleClose} style={{width: '150px', height: '55px', color: colors.darkBlue, border: 'none', borderRadius: '10px', cursor: 'pointer'}}>{texts['button-cancel']}</button>
                <button onClick={confirmDonation} style={{width: '150px', height: '55px', color: colors.white, border: 'none', borderRadius: '10px', background: colors.gradientOrange, cursor: 'pointer'}}>{texts['button-donate']}</button>
            </div>
          </div>
        </Dialog>
    )
}
export default ConfirmDonation;